import Chava1 from '../../../Media/BSD/Tanakayu/Tanakayu Chava.webp'
import Chava2 from '../../../Media/BSD/Tanakayu/Tanakayu Chava.webp'





const Chavaimages =[
Chava1,Chava2
]

export default Chavaimages;